export class NewsController {
  constructor() {
    let newsFilter = document.querySelector('.js-newsCategories');
    if (newsFilter) {
      this.initNewsFilter();
    }
  }

  initNewsFilter() {
    let params = {};
    let search = decodeURIComponent(window.location.href.slice(window.location.href.indexOf( '?' ) + 1 ) );
    let definitions = search.split( '&' );
    let keyParam = 'tx_auspage_onelevelnavigationnoncached[filter][fields][page_categories]';

    definitions.forEach( function( val, key ) {
      let parts = val.split( '=', 2 );
      params[ parts[ 0 ] ] = parts[ 1 ];
    } );
    if (params[keyParam] && params[keyParam] > 0) {
      let selectedNewsCategory = document.querySelector('.js-newsCategory-' + params[keyParam]);
      if (selectedNewsCategory) {
        selectedNewsCategory.classList.add('list__newsCategory--active');
        selectedNewsCategory.addEventListener('click', function (e) {
          e.preventDefault();
          window.location.replace(window.location.href.split('?')[0]);
        });
      }
    }
  }
}

